/*
 * @Author: cxy
 * @Desc:
 * @Date: 2023-12-23 14:57:12
<<<<<<< HEAD
 * @LastEditTime: 2024-08-20 10:29:16
=======
 * @LastEditTime: 2024-08-20 10:25:18
>>>>>>> hotfix/导航栏错误
 */

// with polyfills
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import { VueAxios } from './utils/request'
import ProLayout, { PageHeaderWrapper } from '@ant-design-vue/pro-layout'
import themePluginConfig from '../config/themePluginConfig'
import VueCompositionApi from '@vue/composition-api'
import 'ant-design-vue/dist/antd.min.css'// or 'ant-design-vue/dist/antd.less'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'

import bootstrap from './core/bootstrap'
import './core/lazy_use' // use lazy load components
import './permission' // permission control
import './utils/filter' // global filter
import './assets/style/index.less' // global style
import _ from 'lodash'
// 注册vue全局方法
import vueConfig from './config/vue-extends/'
Vue.use(vueConfig)

Vue.config.productionTip = false
Vue.prototype._ = _
// mount axios to `Vue.$http` and `this.$http`
Vue.use(VueAxios)
Vue.use(VueCompositionApi)
// use pro-layout components
Vue.component('pro-layout', ProLayout)
Vue.component('page-container', PageHeaderWrapper)
Vue.component('page-header-wrapper', PageHeaderWrapper)

Vue.directive('preventReClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 2000)
      }
    })
  }
})

window.umi_plugin_ant_themeVar = themePluginConfig.theme
const feiShuBotHook = process.env.VUE_APP_FEISHU_BOT_HOOK
if (feiShuBotHook) {
  // 系统相关异常错误拦截 & 发送至飞书群机器人
  // eslint-disable-next-line
  window.botReport && botReport.init({
    fetch: false,
    xhr: false,
    botUrl: feiShuBotHook
  })
}

if (process.env.NODE_ENV === 'production') {
  Vue.config.errorHandler = function(err, vm, info) {
    throw new Error(err)
  }
}
// 是否是本地开发环境
const isDev = process?.env?.NODE_ENV === 'development'
if (isDev) {
  import('moment/locale/zh-cn')
}

const log = (message, data = '') => {
  console.log(`\n%c【运营中台】${message}`, 'color:#ffffff; background:#007ec6; font-size:18px; padding:2px 4px; margin: 1rem auto; font-family: Rockwell; border: 2px solid #0dd8d8; border-radius: 4px;font-weight: bold; text-shadow: 1px 1px 1px #00af87bf;', data)
}

const handleMicroDataBefore = async () => {
  if (window.__MICRO_APP_ENVIRONMENT__ && !storage.get(ACCESS_TOKEN)) {
    try {
      console.log(store, '####store###')
      const microAppData = window.microApp.getData()
      if (microAppData && microAppData.token) {
        await store.dispatch('getUserInfoByToken', microAppData.token)
      }
    } catch (error) {
      console.log(error)
      return Promise.resolve(error)
    }
  }
  return Promise.resolve()
}
// 与基座进行数据交互
const handleMicroData = () => {
  // 是否是微前端环境
  if (window.__MICRO_APP_ENVIRONMENT__) {
    // 监听基座下发的数据变化
    window.microApp.addDataListener(async (data) => {
      log('addDataListener', data)
      // 当基座下发path时进行跳转
      if (data.path && data.path !== router.currentRoute.path) {
        router.push(data.path)
      }
    })
    // 向基座发送数据
    // window.microApp.dispatch({ app_name: 'operation-center' })
  }
}

let app = null
/**
 * 挂载函数
 */
function mount() {
  handleMicroDataBefore().then(() => {
    app = new Vue({
      router,
      store,
      created: bootstrap,
      render: h => h(App)
    }).$mount('#app')
    handleMicroData()
    log('挂载完成 🌹🌹')
  })
}

/**
 * 卸载函数
 */
function unmount() {
  app.$destroy()
  app.$el.innerHTML = ''
  app = null
  log('微应用-卸载了😭')
}

// 微前端环境下，注册mount和unmount方法
if (window.__MICRO_APP_ENVIRONMENT__) {
  window[`micro-app-${window.__MICRO_APP_NAME__}`] = { mount, unmount }
} else {
  // 非微前端环境直接渲染
  mount()
}
